export const ICON_PALE = "var(--gv-icon-pale)";
export const ICON_BASE = "var(--gv-icon-base)";
export const PURPLE_500 = "var(--gv-purple500)";
export const LIME_500 = "var(--gv-lime500)";
